export const TRANSLATIONS_KR = {
  leftNavigation: {
    dashboard: "대시보드",
    sessions: "세션",
    teams: "팀",
    profile: "프로필",
    logs: "로그",
    warningLetters: "경고메시지",
    settings: "설정",
    userManagement: "사용자 관리",
    subjectManagement: "과목 관리",
    changePassword: "비밀번호 변경",
    helpAndSupport: "도움말",
    scoresheet: "Scoresheet",
  },
  header: {
    logout: "로그아웃",
    notifications: "알림",
    loadingNotifications: "Loading notifications....",
    stepper: {
      plan: "계획",
      do: "행동",
      check: "점검",
      act: "시정",
    },
  },
  tabs: {
    ceo: "CEO",
    executive: "임원진",
    coe: "COE",
    campaign: "캠페인",
    team: "팀",
    personal: "Personal",
  },
  notification: {
    session: " 과 코칭 세션이 있습니다.",
    on: "에 ",
    checkpointUpdated: "이 체크포인트 날짜를 업데이트 했습니다. ",
    complete: "까지 GROW모델을 완료하시기 바랍니다.",
    growmodel: "이 GROW 모델을 완료하고 초대를 수락하였습니다.",
    progression: "이 귀하의 진행률을 업데이트 했습니다.  ",
    compliment: "이 귀하에게 칭찬을 남겼습니다.",
    rating: "의 코칭세션을 평가하시기 바랍니다. ",
    review: "이 최종 평가날짜를 으로 변경하였습니다.",
    archivedSession: "이 코칭세션을 평가하고 저장하였습니다.",
    checkpoint: "체크포인트",
    updateFor: "update for",
    isAvailable: "is available",
    at: "at",
    today: "today",
    youHaveYetToSetCheckPoint: "대한 체크포인트를 아직 설정하지 않았습니다.",
    by: "에",
    youHaveAReviewSessionWith: "과 평가 세션이 있습니다. ",
    youHaveUpcomingSession: "과의  코칭세션이 예정되어 있습니다.",
    youHaveCompleted: "지난 달 개의 세션을 완료하였습니다.",
    sessionCompletedLastMonth: "지난 달 개의 세션을 완료하였습니다.",
  },
  dashboard: {
    title: "대시보드",
    noDataYet: "데이터가 없습니다.",
    tabs: {
      ceo: "CEO",
      executive: "임원진",
      coe: "COE",
      campaign: "캠페인",
      team: "팀",
      personal: "Personal",
    },
    coachingSessionWith: "과의 코칭세션",
    checkpointSetupFor: "위한 체크포인트 설정",
    checkpointUpdateFor: "위한 체크포인트 업데이트",
    reviewSessionWith: "과의 평가세션",
    average: "평균",
    longest: "가장 긴 세션",
    shortest: "가장 짧은 세션",
    executive: {
      sessionClosed: "종료된 세션",
      overall: "전체",
      totalInprogress: "Total in progress",
      avgUsageRate: "Avg usage rate",
      usageRate: "Usage rate",
      totalSessionClosed: "총 종료된 세션 수",
      totalCoachees: "총 Coachees 수",
      avgSessionClosed: "종료된 세션 평균 수",
      coachingHours: "코칭 시간",
      totalCoachingHours: "총 코칭  소요시간",
      avgCoachingHours: "평균 코칭 소요시간",
      totalPlanDuration: "총 계획 소요시간",
      totalDoDuration: "총 동작 소요시간",
      totalCheckDuration: "총 확인 소요시간",
      totalActDuration: "총 실행 소요시간",
      coachingSubjects: "코칭 과목",
    },
    coach: {
      dashboard: "대시보드",
      report: "보고서",
      upcomingTask: "해야 할 다음 과제",
      overdueTask: "기한이 지난 과제",
      recentTask: "최근 활동",
      top3coaches: "Top 3 coaches",
      campaignSession: "캠페인 세션",
      totalCoach: "Coachess 총 합계",
      coached2OrMoreSession: "Coached된 2개 이상 세션",
      coached1Session: "Coached된 1개 세션",
      notCoachedYet: "실행되지 않은 Coached",
      showResultFor: "결과보기",
      happiness: "만족도",
      complimentLikes: "성취율",
      success: "성공률",
      ratedSession: "평가된 세션",
      totalSession: "총 세션 수",
      likes: "좋아요 수 ",
      totalComplements: "총 칭찬 수 ",
      passRate: "합격률",
      totalSubjects: "총 과목 수",
      comparedTo: "비교하기",
      mostCoachedSubjects: "가장 많이 Coached 과목",
      average: "평균",
      mostFailedSubjects: "가장 많이 실패한 과목",
      topSkillsToImprove: "개선이 필요한 주요 스킬",
      teamAverage: "팀 평균",
      coach: "Coach",
      typeOfSession: "세션 타입",
      subjects: "과목",
      session: "세션",
      sessionDuration: "세션 소요기간",
      length: "길이",
      minutes: "시간(분)",
      longest: "가장 긴 세션",
      shortest: "가장 짧은 세션",
      plan: "계획",
      do: "동작",
      check: "확인",
      act: "실행",
      total: "합계",
      individual: "개인",
      metricsHead: "팀 멤버 coached된 세션",
      complianceRate: "Compliance Rate",
      incompleteRate: "Incomplete Rate 미수료율",
      conditionalPassRate: "Conditional pass rate 조건부수료율",
      campaign: "캠페인",
      sessions: "세션",
      manual: "매뉴얼",
      expired: "만료된 세션",
      team: "팀",
      campaignAverage: "캠페인 평균",
      topCountries: "Top countries",
    },
    personal: {
      dashboard: "대시보드",
      showResultFor: "결과보기",
      happiness: "만족도",
      complimentLikes: "성취율",
      success: "성공률",
      ratedSession: "평가된 세션",
      totalSession: "총 세션 수",
      likes: "좋아요 수",
      totalComplements: "총 칭찬 수 ",
      passRate: "합격률",
      totalSubjects: "총 과제 수",
      latestCompliments: "가장 최근 칭찬들",
      comparedToTeamAvg: "팀 평균 비교하기",
      mostCoachedSubjects: "가장 많이 코칭된 과목",
      mostFailedSubjects: "가장 많이 실패한 과목",
      topSkillsToImprove: "개선이 필요한 주요스킬",
      individual: "개인",
      teamAverage: "팀 평균",
      subjects: "Subjects",
      session: "Sessions",
    },
    selectReport: "Select Report",
    overallCoachingSessionsReport: "Overall Coaching Sessions Report",
    sessionDiscussionReport: "Session Discussion Report",
    monthly: "Monthly",
    custom: "Custom",
    cancel: "Cancel",
    download: "Download",
  },
  sessionList: {
    title: "세션",
    totalSessionPending: "총 보류중인 세션 수",
    allCoaches: "모든 Coaches",
    allStatus: "모든 진행상황",
    upcomingSession: "해야 할 다음 세션",
    sessionDateTime: "Session Date",
    time: "시간",
    type: "타입",
    subjects: "과목",
    coach: "Coach",
    coachee: "Coachee",
    status: "진행상황",
    createSession: "세션 만들기",
    allCountries: "모든 나라보기",
    allCampaign: "모든 캠페인보기",
    sessionSuccess: "성공적으로 종료된 세션",
    name: "이름",
  },
  createSession: {
    backToSession: "세션 뒤로가기",
    createNewSession: "새로운 세션 만들기",
    campaign: "캠페인",
    coachee: "Coachee",
    coach: "Coach",
    assignToOtherCoach: "다른 Coach에게 권한 부여하기",
    assignTo: "권한 부여하기",
    selectTeamMember: "팀 멤버 선택하기",
    viewCoacheesStates: "코칭 대상자 로그 기록 보기",
    coachingDate: "코칭 날짜",
    method: "방법",
    framework: "프레임워크",
    reviewDate: "평가 날짜",
    typeOfSession: "세션 타입",
    addSubjects: "과목 추가하기",
    sessionNotes: "세션 노트",
    keyPoint: "핵심요점",
    addNewNote: "내용을 입력 해 주세요",
    compliment: "칭찬",
    casualNote: "추가메모",
    createSendInvitation: "세션 만들고 안내메일 보내기",
    assignFieldMandatory: "권한 부여하기는 필수 요소입니다.",
    coacheeFieldMandatory: "Coachee 선택하기는 필수 요소입니다.",
    logs: "로그",
    complettionDate: "수료일",
    duration: "소요시간",
    type: "타입",
    subjects: "과목",
    name: "이름",
    status: "진행상황",
    noTeamLogsFound: "저장된 팀 기록이 없습니다.",
    close: "닫기",
    methodIsMandatory: "방법 선택은 필수 요소입니다.",
    frameworkIsMandatory: "프레임워크 선택은 필수 요소입니다.",
    sessionTypeIsMandatory: "세션 타입 선택은 필수 요소입니다.",
    pleaseAddAtLeastOneSubject: "최소한 한개 과목을 추가해주세요.",
    selectAcoach: "Coach 선택하기",
    ErrorNetworkError: "경고: 네트워크를 확인 해 주세요.",
    notes: "메모F",
  },
  sessionDetails: {
    backtosession: "세션 뒤로가기",
    sessionDetails: "세션 세부사항",
    coach: "Coach",
    coachee: "Coachee",
    caochingDate: "코칭날짜",
    reviewDate: "평가 날짜",
    typeofSession: "세션 타입",
    subjects: "과목",
    gentleReminderTitle: "알림",
    gentleReminder:
      "알림: 준비하기 시작 버튼을 누르기 전에 오른쪽 창의 핵심요점을 읽어시기 바랍니다.",
    startPreparation: "준비 시작하기",
  },
  growForm: {
    planSessionBasedonGrowModel: "GROW 모델에 기초하여 세션 계획 세우기",
    yourReviewSessionIsOn: "평가 세션 일정은 다음과 같습니다.",
    goals: "목표",
    comment: "코멘트",
    knowingYourCoachingSubjectsAndCreate:
      "SMART 목표를 사용하여 코칭 과목 숙지하고 평가 날짜까지 목표치를 달성할 수 있는 계획을 수립합니다.",
    SMARTGolasIsAnEstablished:
      "SMART 목표는 목표를 계획하고 달성할 수 있는 확립된 방법입니다. SMART 목표를 만들면 달성하고자 하는 목표, 목표 달성 방법, 목표 달성 및 관련성 여부, 목표 달성 시기를 파악할 수 있습니다.",
    reality: "현실",
    current: "현재",
    target: "목표",
    enterMetrics: "메트릭스를 입력 하시기 바랍니다.",
    knowingYourCurrentPerformance:
      "코칭 과목과 관련하여 현재 성과를 알고 있습니다.",
    options: "옵션",
    brainstormForMultipleOptionsToImprove:
      "목표 달성을 위해 코칭 대상을 개선하기 위한 여러가지 옵션을 브레인스토밍 합니다.기회의 영역을 닫는 데 도움이 될 수 있는 가능한 기술을 열거 하세요. 이 단계는 가능한 해결책을 탐구하는 창의성을 장려합니다.",
    wayForward: "앞으로 나아가기",
    selectTheMostFeasibleOptions:
      "목표에 성공적으로 도달할 수 있는 가장 실현 가능한 옵션을 선택하세요.",
    saveAndConfirmSession: "세션 확인하고 저장하기",
    startCoachingSession: "코칭 세션 시작하기",
    edit: "수정",
    startCoaching: "코칭 시작",
    proceedToSummary: "요약하기",
    skillToImprove: "필요한 역량",
    selectSkill: "역량 선택하기",
    pleaseSelectSkillsToImprove: "필요한 역량을 선택해 주시기 바랍니다.",
    enterProjectKpi: "Enter Project Target KPI",
    projectTargetKpi: "Project Target KPI",
  },
  coachingSummary: {
    coachingSummary: "코칭 요약본",
    coach: "Coach",
    coachee: "Coachee",
    coachingDate: "코칭 날짜",
    method: "방법",
    typeOfSession: "세션 타입",
    goals: "목표치",
    reality: "현실",
    current: "현재",
    target: "목표",
    skillToImprove: "필요한 역량",
    options: "옵션",
    wayForward: "나아가기",
    yourReviewSessionWillBe: "평가 세션 일정은 다음과 같습니다.",
    progressionCheckpoints:
      "체크포인트 진행은 코치가 평가 날짜전에 설정하고 업데이트 합니다.",
    acknowledgement: "Acknowledgement",
    enterPassword: "비밀번호 입력하기",
    pleaseEnterPassword: "비밀번호를 입력하시기 바랍니다.",
    endCoaching: "코칭 종료하기",
    byAcknowledgingthisGrow:
      "본 GROW양식에 따라 명시된 액션플랜을 작업하기로 동의합니다.",
    cancel: "취소",
    agree: "동의하기",
  },
  setCheckpoint: {
    backToSession: "세션 뒤로가기",
    setCheckpoint: "체크포인트 설정하기",
    viewSessionSummary: "세션 요약 보기",
    rateCoacheesBehaviour: "Coachee 태도 평가하기",
    checkpoint: "체크포인트",
    addCheckpoint: "체크포인트 추가하기",
    reviewDate: "평가 날짜",
    gentleReminder: "알림: 평가가 완료 되면 다시 변경 할 수 없습니다.",
    pleaseRateTheCoachees: "Coachee 평가를 해 주세요.",
    confirmRatingAndCheckpoints: "체크포인트 및 평가 완료",
  },
  sessionSummary: {
    viewSessionSummary: "세션 요약 보기",
    coachingDate: "코칭 날짜",
    method: "방법",
    typeOfSession: "세션 타입",
    goals: "목표",
    reality: "현실",
    current: "현재",
    target: "목표 ",
    skillsToImprove: "필요한 역량",
    options: "옵션",
    wayForward: "나아가기",
  },
  updateCheckpoint: {
    updateCheckpoint: "체크포인트 점수 변경하기",
    edit: "수정",
    viewSessionSummary: "세션 요약 보기",
    reviewDate: "평가 날짜",
    checkpoint: "체크포인트",
    final: "최종날짜",
    previous: "이전",
    checkpointProgressScore:
      "체크포인트 진행 점수가 성공적으로 저장되었습니다.",
    saveProgress: "진행 점수를 저장하시기 바랍니다.",
    startReviewSession: "평가 세션 시작하기",
    postPoneReviewSession: "평가 세션 일정 변경하기",
    postPoneReviewSessionTo: "다음의 일정으로 평가 세션 변경",
    pleaseStateReason: "이유를 입력해 주세요.",
    cancel: "취소",
    schedule: "변경하기",
  },
  reviewSession: {
    reviewSession: "Review 평가 세션",
    finalReview: "최종 평가",
    final: "최종 점수",
    summary: "요약하기",
    proceedToSummary: "요약하기",
    summaryFieldIsRequired: "필수 입력 사항입니다.",
    sessionReviewSummarySavedSuccessfully:
      "평가세션 요약내용이 성공적으로 저장되었습니다.",
    endReviewSession: "평가 세션 종료하기",
    done: "완료",
  },
  archiveSession: {
    backtoSession: "세션 뒤로가기",
    backToLog: "Back to Logs",
    archiveSession: "세션 저장하기",
    areYouSatisfied: "이 세션에 만족하십니까?",
    pleaseReadTHeSessionSummary:
      '세션에 관하여 정리된 요약본을 자세히 읽어주시기 바랍니다. 이 세션이 저장되면 더 이상 "Like"칭찬 평가를 할 수 없습니다.',
    totalDuration: "총 소요시간",
    durationBreakdown: "소요시간 목록",
    viewReviewSessionSummary: "세션 요약 보기",
    coacheesBehaviour: "Coachee's 태도",
    reviewDate: "평가 날짜",
    finalReview: "최종 평가",
    summary: "요약",
    notes: "메모",
    selectYourFeedback: "피드백을 선택하세요",
  },
  personalProfile: {
    fullName: "이름",
    employeeID: "직원 ID",
    campaign: "캠페인",
    market: "마켓",
    designation: "직함",
    coach: "Coach",
    viewSession: "세션 보기",
    viewLogs: "로그 보기",
    personalProfile: "개인정보",
  },
  teams: {
    coach: "Coach",
    taggedCoaches: "태그된 코치이름",
    untaggedCoachees: "태그되지 않은 코치이름",
    searchFilter: "검색 필터",
    employeeId: "직원 ID",
    Campaign: "캠페인",
    department: "부서",
    subunit: "하위 단위",
    lastSession: "지난 세션",
    upcommingSession: "해야 할 다음 세션",
    totalCoachees: "총 Coachees 수",
    members: "멤버들",
    coaches: "코치",
    allCountries: "모든 나라보기",
    allCampign: "모든 캠페인보기",
    teams: "팀",
    name: "이름",
  },
  logs: {
    allCoaches: "모든 coaches",
    searchFilter: "검색 필터",
    completionDate: "수료일",
    duration: "소요시간",
    subjects: "과목",
    type: "Type",
    coach: "Coach",
    coachee: "Coachee",
    status: "진행상황",
    totalLogs: "총 로그 기록",
    averageDuration: "평균 소요시간 (분)",
    longestDuration: "가장 긴 소요시간 (분)",
    shortestDuration: "가장 짧은 소요시간 (분)",
    filter: "필터",
    names: "이름",
    name: "이름",
    clearAll: "모두 지우기",
    allCountries: "모든 나라보기",
    AllCampaign: "모든 캠페인보기",
  },
  userManagement: {
    searchFilter: "검색 필터",
    name: "이름",
    id: "Id",
    campaign: "캠페인",
    department: "부서",
    country: "국가",
    designation: "직함",
    role: "Role",
    status: "진행상황",
    editUser: "사용자 수정하기",
    fullName: "이름",
    employeeID: "직원 ID",
    adminRole: "Admin 권한 설정",
    managerCoache: "Coachee  관리하기",
    AddCoach: "Coach 추가하기",
    userStatus: "사용자 진행상황",
    resetPassword: "비밀번호 다시 설정하기",
    saveChanges: "변경사항 저장하기",
    cancel: "취소",
    add: "추가하기",
    userDetailsUp: "사용자 정보가 성공적으로 수정되었습니다.",
    pleaseSaveToResetThe: "설정 된 비밀번호를 저장하세요. ",
  },
  subjectManagement: {
    searchFilter: "검색 필터",
    campaign: "캠페인",
    department: "부서",
    lastEdited: "최근 수정한 사람",
    date: "날짜",
    subjectFor: "과목 대상자",
    status: "진행상황",
    country: "국가",
    coachingCategory: "코칭 카테고리",
    subCategory: "하위 카테고리",
    dataType: "데이터 타입",
    conditionToPass: "합격 조건",
    framework: "프레임워크",
    enterSubCategory: "하위 카테고리를 입력하세요",
    selectType: "타입 선택하기",
    selectCondition: "합격 조건 선택하기",
    selectFramework: "프레임워크 선택하기",
    addSubCategory: "하위 카테고리 추가하기",
    skillToImprove: "필요한 역량",
    enterSkillToImprove: "필요한 역량을 입력하세요",
    addLevel: "단계 추가하기",
    addSkillToImprove: "기술 추가하기",
    actionAtCheckpoint: "체크포인트에서 실행하기",
    enterAction: "액션을 입력해주세요",
    addAction: "액션 추가하기",
    saveChanges: "변경사항 저장하기",
    cancel: "취소",
    editSubject: "과목 수정하기",
    subjectDetails: "세부사항이 업데이트 되었습니다",
    noRecordFound: "관련 기록이 없습니다.",
    somethingWentWrong: "잘못 입력되었습니다. 다시 시도 해 주세요.",
    functionalUnit: "Sub Functional Unit",
  },
  changePassword: {
    enterYourCurrentPassowrd: "현재 비밀번호를 입력합니다.",
    chooseAStrongPassword:
      "다른 계정에서 사용되지 않고 노출이 쉽지 않은 비밀번호로 설정 바랍니다.",
    newPassword: "새 비밀번호",
    passwordStrength: "비밀번호 안전성",
    useAtLeast12Charecters:
      "최소 12자  이상이어야 하며, 다른 계정과 동일한 비밀번호, 혹은 너무 쉬운 비밀번호는 설정하지 마시기 바랍니다.",
    confirmNewPassword: "새 비밀번호 확인",
    changePassword: "비밀번호 변경",
    thePasswordDoNotMatch: "비밀번호가 일치하지 않습니다.",
    passwordMustBeAtLeast12:
      "비밀번호는 12자 이상이어야 하며, 대문자, 소문자, 숫자 및 특수 문자가 혼합되어 있어야 합니다.",
    passwordCannotBeSameAsOldPassword: "New password cannot be same as old password",
  },
  error: {
    loginerror: "사용자 이름과 비밀번호가 일치하지 않습니다.",
    usererror: "사용자 아이디가 활성화 되어있지 않습니다.",
    internalServerError: "문제가 발생했습니다. 다시 시도하십시오.",
    networkerror: {
      500: "문제가 발생했습니다. 다시 시도하십시오.",
    },
    paramerror: "'{{property}} 값은 Null일 수 없습니다.",

    passwordvalidationerror:
      "비밀번호는 10자 이상이어야 하며, 대문자, 소문자, 숫자 및 특수 문자가 혼합되어 있어야 합니다.",
    newpasswordvalidationerror:
      "새로운 비밀번호와 확인란의 비밀번호가 일치 하지 않습니다.",
    oldpasswordvalidationerror: "기존 비밀번호가 일치하지 않습니다.",
    successpasswordvalidationerror: "비밀번호가 성공적으로 변경되었습니다.",
    noSessionDetailsFound: "No session details found",
    verbalWarningIssued: "Verbal warning issued",
    verbalWarningIssueFailed: "Failed to issue verbal warning, try again",
    alreadyTwoVerbalWarningIssued:
      "Already 2 verbal warning issued, try for other",
    checkpointProgressScoreHasBeenSavedSuccessfully:
      "Checkpoint Progress Score has been saved successfully",
    updatedCheckpointsSuccessfully: "Updated Checkpoints successfully",
    sessionReviewSummaryHasBeenSavedSuccessfully:
      "Session Review Summary has been saved successfully",
    selectedCoachIsAlreadyInTheList: "Selected Coach is already in the list",
    somethingWentWrongPleaseTryAgain: "something went wrong, please try again",
    couldNotGetSession: "Could not get session.",
    selectedCoacheeIsAlreadyBeenAdded: "Selected coachee is already been added",
    selectedCountryIsAlreadyInTheList:
      "Selected Country is already in the list",
    canNotUpdateActionAtCheckPoint: "can't update action_at_checkpoint!",
    couldNotGetCountryList: "Could not get Country List",
    couldNotGetNotification: "Could not get notification",
    errorGettingReviewDateSummary: "Error getting Review Date Summary",
    pleaseSelectCoachee: "Please select Coachee",
    couldNotGetGrowFormDetailsFromSessionId:
      "Could not get grow form details from session id",
    pleaseSelectSubjectAndAddMetrics: "Please select subject and add metrics",
    couldNotGetSkillsListBasedOnSubjectId:
      "Could not get Skills list based on subject id",
  },
  editSessionCoachingDates: {
    title: "Postpone Session Dates",
    update: "Update",
  },
  common: {
    noRecordFound: "No record found",
    backToSession: "세션 뒤로가기",
  },
};
